<template>
  <div class="d-flex flex-row justify-content-center fs-8px ">
    <i v-if="score <= 0" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 0.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>

    <i v-if="score <= 1" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 1.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>


    <i v-if="score <= 2" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 2.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>

    <i v-if="score <= 3" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 3.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>

    <i v-if="score <= 4" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 4.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>
  </div>
</template>

<script>
export default {
  name: 'CustomerRating',
  props: ['rating'],
  data() {
    return {

    }
  },
  computed: {
    score() {
      if (this.rating < 100) {
        return 0;
      }
      else if (this.rating < 200) {
        return 0.5;
      }
      else if (this.rating < 500) {
        return 1;
      }
      else if (this.rating < 1000) {
        return 1.5;
      }
      else if (this.rating < 2000) {
        return 2;
      }
      else if (this.rating < 5000) {
        return 2.5;
      }
      else if (this.rating < 10000) {
        return 3;
      }
      else if (this.rating < 15000) {
        return 3.5;
      }
      else if (this.rating < 25000) {
        return 4;
      }
      else if (this.rating < 40000) {
        return 4.5;
      } else {
        return 5;
      }

    }
  }
}
</script>